import type { ButtonHTMLAttributes } from "react";
import { cn } from "../../lib/utils.js";

type ButtonVariant = "primary" | "gradient-outline" | "secondary";

const variantClasses: Record<ButtonVariant, string> = {
  primary:
    "inline-flex items-center justify-center gap-2 rounded-xl px-5 py-3 text-sm font-medium text-white transition-[transform,background-color] duration-150 shadow-[var(--glow-accent)] bg-[var(--cta)] hover:bg-[var(--cta-hover)] active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50",
  secondary:
    "inline-flex items-center justify-center gap-2 rounded-xl border border-[var(--glass-border)] px-5 py-3 text-sm font-medium text-[var(--text-secondary)] transition-colors hover:bg-white/5 hover:text-[var(--text-primary)] disabled:cursor-not-allowed disabled:opacity-50",
  "gradient-outline":
    "inline-flex items-center justify-center gap-2 rounded-xl border border-transparent px-5 py-3 text-sm font-medium text-[var(--text-primary)] transition-transform duration-150 hover:brightness-110 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50 [background:linear-gradient(transparent,transparent)_padding-box,linear-gradient(135deg,var(--accent-from),var(--accent-via),var(--accent-to))_border-box]",
};

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
}

export function Button({ className, variant = "primary", type = "button", ...props }: ButtonProps) {
  return <button type={type} className={cn(variantClasses[variant], className)} {...props} />;
}
